import { ContextStore } from '../../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../../react-core/Async/Promise';
import { TransferDestinationAccountPaginatedModel } from '../../../Models/Domains/Transfer/TransferDestinationAccountPaginatedModel';
import { SubAccountType } from '../../../Constants/Enums/Domain/SubAccountType';
import { ServiceProposition } from '../../../Constants/Enums/ServiceProposition';

declare var IS_RUNNING_IN_APP_POOL;

export class TransferDestinationAccountsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(accountName: string, clAccountId: string, clientForeName: string, clientSurName: string, maxRow: number, minRow: number, type: SubAccountType, wrapProvider: string, serviceProposition: ServiceProposition): Promise<TransferDestinationAccountPaginatedModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Transfer/TransferDestinationAccounts/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { accountName: accountName, clAccountId: clAccountId, clientForeName: clientForeName, clientSurName: clientSurName, maxRow: maxRow, minRow: minRow, type: type, wrapProvider: wrapProvider, serviceProposition: serviceProposition }

    return AjaxWrapper.get<TransferDestinationAccountPaginatedModel, any>(url, data);
  }
}

